import { Tooltip } from 'antd'
import CustomTag from 'components/CustomTag'
import {
  RowNumberData,
  RowNumberDataReport,
  RowNumberDataReportAlignCenter,
  SkillRow,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import {
  DateFormat,
  RefinedData,
  arrayIntoString,
} from 'modules/Report/CommonFunction/Function.js'
import { HiringLevelTitle } from 'modules/Report/ExcelHeaderData.js'
import PageContent from 'modules/Report/Partials/CommonTable/PageContent.js'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import WarningMessage from 'utils/WarningMessage'
import { permittedSubEvents } from '../../../../utils/permissionsValidation'
import { serialNo } from '../../CommonFunction/Function'
import { setHiringLevel } from '../../action'
const HiringStatus = ({
  cityData,
  cityDetails,
  hiringLevelDetails,
  rolesPublishedData,
  excelDataForReport,
  roleDetails,
  roleData,
  corporateData,
}) => {
  const dispatch = useDispatch()
  const [dateError, setDateError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [excelLoading, setExcelLoading] = useState(false)
  const [loadingRole, setLoadingRole] = useState(false)
  const [searchCityValue, setSearchCityValue] = useState('')
  const [loadingRoleFilter, setLoadingRoleFilter] = useState(false)
  const [searchRoleValue, setSearchRoleValue] = useState('')
  const [tierValue, setTierValue] = useState([])
  const [cityValue, setCityValue] = useState([])
  const [roleValue, setRoleValue] = useState([])
  const [collegeValue, setCollegeValue] = useState([])
  const [debounced, setDebounced] = useState(() => roleNameValue)
  const [createdAtStart, setCreatedAtStart] = useState('')
  const [offerRaisedFilter, setOfferRaisedFilter] = useState('')
  const [offerAppliedFilter, setOfferAppliedFilter] = useState('')
  const [lastDate, setLastDate] = useState('')
  const [createdAtEnd, setCreatedAtEnd] = useState('')
  const [appendDateFilter, setAppendDateFilter] = useState([])
  const [clearDate, setClearDate] = useState(false)
  const [clearJoiningDate, setClearJoiningDate] = useState(false)
  const [roleNameValue, setRoleNameValue] = useState()
  const [clear, setClear] = useState(false)
  const [error, setError] = useState('')
  const [rank, setRank] = useState('')
  const [rankSign, setRankSign] = useState('')
  const [filterData, setFilterData] = useState({
    tier: '',
    job: '',
    college: '',
    createdAtEnd: '',
    createdAtStart: '',
    appenddate: '',
    offered: '',
    accepted: '',
    rank: '',
    rankSign: '',
    round: '',
    type: '',
  })
  const [tooltip, setTooltip] = useState(false)
  const [sortBy, setSortBy] = useState({
    orderBy: 'desc',
    sortName: 'b.posted_date',
  })
  const [isExcel, setIsExcel] = useState('')
  const [excel, setExcel] = useState([])
  const [previousPage, setPreviousPage] = useState('')
  const onPageChange = pageNum => {
    setPreviousPage(currentPage)
    setCurrentPage(pageNum)
  }
  function hasData(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== '') {
        return true
      }
    }
    return false
  }
  useEffect(() => {
    dispatch(setHiringLevel())
  }, [])
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(roleNameValue)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [roleNameValue])

  const clearFilter = () => {
    setCityValue([])
    setTierValue([])
    setCollegeValue([])
    setRoleValue([])
    setRoleNameValue('')
    setOfferRaisedFilter('')
    setOfferAppliedFilter('')
    setCreatedAtStart('')
    setCreatedAtEnd('')
    setLastDate('')
    setClearDate(true)
    setClearJoiningDate(true)
    setRank('')
    setRankSign('')
    setSearchCityValue('')
    setSearchRoleValue('')
    dispatch(setHiringLevel())
    setClear(true)
    setFilterData({ tier: '', city: '' })
  }
  const applyFilter = () => {
    let filterData = {
      tier: arrayIntoString(tierValue),
      city: arrayIntoString(cityValue),
      college: arrayIntoString(collegeValue),
      role: arrayIntoString(roleValue),
      createdAtStart: createdAtStart,
      createdAtEnd: createdAtEnd,
      appenddate: lastDate,
      offered: arrayIntoString(offerRaisedFilter),
      accepted: arrayIntoString(offerAppliedFilter),
      rank: rank,
      rankSign: rankSign,
    }

    if (createdAtStart) {
      if (!createdAtEnd) {
        WarningMessage(
          <>
            Kindly select <q>To Date</q> from Date Range
          </>
        )
      }
    }

    if (createdAtEnd) {
      if (!createdAtStart) {
        WarningMessage(
          <>
            Kindly select <q>From date</q> from Date Range
          </>
        )
      }
    }

    if (createdAtEnd && createdAtStart && error == '') {
      setFilterData(filterData)
    }
    if (!createdAtEnd && !createdAtStart && error == '' && !dateError) {
      setFilterData(filterData)
    }
    if (error || dateError) {
      setTooltip(true)
      WarningMessage(<>Kindly check the error in filter</>)
    }
  }
  useEffect(() => {
    if (error !== '' || dateError) {
      setTooltip(true)
    }
  }, [error, dateError])
  function toCamelCase(str) {
    const words = str.split(' ')
    const camelCaseWords = words.map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    return camelCaseWords.join(' ')
  }
  const tableData = excelDataForReport?.result?.map((item, index) => [
    { value: index + 1 },
    {
      value: item.tittle ? item.tittle : '-',
    },
    { value: item.posted_date ? DateFormat(item.posted_date) : '-' },
    { value: item.start_date ? DateFormat(item.start_date) : '-' },
    {
      value: item.first_name
        ? item.first_name +
          (item.last_name ? ' ' + String(item.last_name).trim() : '')
        : '-',
    },
    { value: item.work_experience ? item.work_experience : '-' },
    {
      value: item.short_form ? item.short_form : '-',
    },
    { value: item.department ? toCamelCase(item.department) : '-' },
    { value: item.skills ? RefinedData(JSON?.parse(item.skills)) : '' },
    { value: item.created_at ? DateFormat(item.created_at) : '-' },
    {
      value: item.offer_joining_date
        ? DateFormat(item.offer_joining_date)
        : '-',
    },
    {
      value: item.job_location ? toCamelCase(item.job_location) : '-',
    },
  ])
  const excelData = [{ columns: HiringLevelTitle, data: tableData }]
  const onSorting = (pagination, row, sorter) => {
    let order = 'desc'
    let sort = sorter.field
    if (sorter.order === 'descend') {
      //
    } else if (sorter.order === 'ascend') {
      order = 'asc'
    } else {
      sort = 'b.posted_date'
    }
    let sortBy = {
      orderBy: order,
      sortName: sort,
    }
    setSortBy(sortBy)
  }

  useEffect(() => {
    if (hasData(filterData)) {
      if (currentPage) {
        if (hasData(filterData))
          hiringLevelDetails(
            10,
            currentPage,
            setLoadingRole,
            roleNameValue,
            filterData,
            sortBy
          )
      }
    }
  }, [currentPage])
  useEffect(() => {
    if (hasData(filterData))
      hiringLevelDetails(
        10,
        1,
        setLoadingRole,
        roleNameValue,
        filterData,
        sortBy
      )
    setCurrentPage(1)
  }, [filterData, debounced, sortBy])
  useEffect(() => {
    setTierValue([])
  }, [])
  useEffect(() => {
    let filterData = {
      city: arrayIntoString(cityValue),
      role: arrayIntoString(roleValue),
      createAtStart: createdAtStart,
      createAtEnd: createdAtEnd,
      appenddate: lastDate,
      rank: rank,
      rankSign: rankSign,
    }

    setTooltip(hasData(filterData))
  }, [
    cityValue,
    roleValue,
    createdAtStart,
    createdAtEnd,
    lastDate,
    rank,
    rankSign,
    clear,
    clearJoiningDate,
    clearDate,
  ])
  const columns = [
    {
      title: 'SR. NO',
      dataIndex: 'id',
      width: '5%',
      align: 'center',
      render: (text, record, index) => (
        <RowNumberDataReportAlignCenter>
          {serialNo(index, previousPage, currentPage, loadingRole)}
        </RowNumberDataReportAlignCenter>
      ),
    },

    {
      title: 'Role',
      width: '20%',
      dataIndex: 'b.tittle',
      sorter: true,
      render: (_, { tittle }) => (
        <RowNumberDataReport>{tittle}</RowNumberDataReport>
      ),
    },
    {
      title: 'Role Posted',
      dataIndex: 'b.posted_date',
      sorter: true,
      align: 'center',
      render: (_, { posted_date }) => (
        <RowNumberDataReportAlignCenter>
          {DateFormat(posted_date)}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'Date of app.',
      sorter: true,
      align: 'center',
      dataIndex: 'b.start_date',
      render: (_, { start_date }) => (
        <RowNumberDataReportAlignCenter>
          {DateFormat(start_date)}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'Candidate name',
      dataIndex: 'd.first_name',
      sorter: true,
      render: (_, { first_name, last_name }) => (
        <RowNumberDataReport>
          {first_name + (last_name ? ' ' + String(last_name).trim() : '')}
        </RowNumberDataReport>
      ),
    },
    {
      title: 'Exp.level',
      dataIndex: 'd.work_experience',
      sorter: true,
      align: 'center',
      render: (_, { work_experience }) => (
        <RowNumberDataReportAlignCenter>
          {' '}
          {work_experience || '-'}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'degree',
      dataIndex: 'e.degree',
      key: 'e.degree',
      sorter: true,
      render: (_, { short_form, degree }) => (
        <RowNumberDataReport>
          {' '}
          {short_form
            ? short_form + ' - ' + toCamelCase(degree)
            : toCamelCase(degree)}
        </RowNumberDataReport>
      ),
    },
    {
      title: 'course',
      dataIndex: 'e.department',
      key: 'e.department',
      sorter: true,
      render: (_, { department }) => (
        <RowNumberDataReport>
          {department ? toCamelCase(department) : '-'}
        </RowNumberDataReport>
      ),
    },
    {
      title: 'Primary Skills',
      dataIndex: 'e.skills',
      key: 'e.skills',
      render: (_, { skills }) => (
        <RowNumberDataReport>
          <Tooltip title={skills ? RefinedData(skills) : ''}>
            {skills ? (
              <SkillRow>
                {skills?.length > 1 ? (
                  <>
                    <CustomTag
                      message={skills?.[0]?.name}
                      bordered={true}
                      background="#F2F3F5"
                      colorType="#808697"
                      border="#F2F3F5"
                    />
                    <CustomTag
                      message={`+${skills?.length - 1}`}
                      bordered={true}
                      background="#F2F3F5"
                      colorType="#808697"
                      border="#F2F3F5"
                    />
                  </>
                ) : skills?.length === 1 ? (
                  <CustomTag
                    message={skills?.[0]?.name}
                    bordered={true}
                    background="#F2F3F5"
                    colorType="#808697"
                    border="#F2F3F5"
                  />
                ) : (
                  <RowNumberData>-</RowNumberData>
                )}
              </SkillRow>
            ) : (
              <RowNumberData>-</RowNumberData>
            )}
          </Tooltip>
        </RowNumberDataReport>
      ),
    },
    {
      title: 'off.date',
      dataIndex: 'c.created_at',
      key: 'created_at',
      align: 'center',
      render: (_, { created_at }) => (
        <RowNumberDataReportAlignCenter>
          {created_at ? DateFormat(created_at) : '-'}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'Joining date',
      dataIndex: 'c.offer_joining_date',
      key: 'offer_joining_date',
      align: 'center',
      render: (_, { offer_joining_date }) => (
        <RowNumberDataReportAlignCenter>
          {offer_joining_date ? DateFormat(offer_joining_date) : '-'}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'Joining location',
      dataIndex: 'c.job_location',
      key: 'c.job_location',
      sorter: true,
      render: (_, { job_location }) => (
        <RowNumberDataReport>{job_location}</RowNumberDataReport>
      ),
    },
  ].filter(item => !item.hidden)
  const clickedExcel = data => {
    let excel = true
    hiringLevelDetails(
      5000,
      1,
      setExcelLoading,
      roleNameValue,
      filterData,
      sortBy,
      excel
    )
    setIsExcel(data)
  }

  useEffect(() => {
    if (
      (excelDataForReport?.result && tableData && isExcel == 'excel') ||
      (excelDataForReport?.result && tableData && isExcel == 'pdf')
    ) {
      if (loadingRole) {
        setExcel([])
      } else {
        setExcel(excelData)
      }
    }
  }, [excelDataForReport?.result, loadingRole])
  const handleHover = () => {
    if (rolesPublishedData?.count > 5000) {
      WarningMessage(
        'Note : The Roles Wise Hiring Status count should not exceed 5,000 for data export.  Apply filters if necessary'
      )
    }
  }
  const dataSign = data => {
    setRankSign(data.rankSign)
    setRank(data.rank)
  }
  const FilterData = [
    {
      id: 3,
      headerName: 'Role',
      searchValue: searchRoleValue,
      setSearchValue: setSearchRoleValue,
      setValue: setRoleValue,
      value: roleValue,
      data: roleData,
      apicall: roleDetails,
      setLoading: setLoadingRoleFilter,
      loading: loadingRoleFilter,
      valueParam: 'id',
      labelParam: 'tittle',
      divider: false,
      flag: 'HS',
    },
    {
      id: 8,
      headerName: 'Location',
      searchValue: searchCityValue,
      setSearchValue: setSearchCityValue,
      value: cityValue,
      setValue: setCityValue,
      data: cityData,
      apicall: cityDetails,
      setLoading: setLoading,
      loading: loading,
      valueParam: 'job_location',
      labelParam: 'job_location',
      divider: true,
      flag: 'HS',
    },
    {
      id: 6,
      headerName: 'Rank',
      setRank: setRank,
      setRankSign: setRankSign,

      divider: false,
    },

    {
      id: 7,
      headerName: 'Joining Date',
      setCreatedAtStart: setLastDate,
      setCreatedAtEnd: setLastDate,
      clearDate: setClearJoiningDate,
      clear: clearJoiningDate,
    },

    {
      id: 1,
      headerName: 'Date Range',
      setCreatedAtStart: setCreatedAtStart,
      setCreatedAtEnd: setCreatedAtEnd,
      clearDate: setClearDate,
      clear: clearDate,
    },
  ]
  const onStatusFilterChanges = (name, status) => {
    const filterValue = status.length ? [status[status.length - 1]] : []
    if (name === 'Offer Raised') {
      setOfferRaisedFilter(filterValue)
    } else if (name === 'Offer Accepted') {
      setOfferAppliedFilter(filterValue)
    }
  }

  const permission = useSelector(state => state?.auth?.permissions)
  const subEvents = permittedSubEvents(permission, 'REPORTS', 'Hiring Status')
  return (
    <>
      {' '}
      <PageContent
        corporateName={corporateData?.name}
        columnWidths={[15, 35, 22, 22, 25, 20, 20, 30, 30, 23, 23, 20]} // Array of column widths
        columnFontSize={10} // Font size for the column data
        HAlign={[
          'center',
          'left',
          'center',
          'center',
          'left',
          'center',
          'center',
          'left',

          'left',
          'center',
          'center',
        ]}
        pdfCellWidth={24.5}
        filterData={FilterData}
        cityData={cityData}
        cityDetails={cityDetails}
        pageHeader="Roles Wise Hiring Status"
        hasProp={hasData(filterData)}
        column={columns}
        tableData={rolesPublishedData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        onPageChange={onPageChange}
        setSearchRoleValue={setRoleNameValue}
        searchRoleValue={roleNameValue}
        applyFilter={applyFilter}
        clearFilter={clearFilter}
        onChange={onSorting}
        width={'100'}
        loadingRole={loadingRole}
        tooltip={tooltip}
        handleHover={handleHover}
        clickedExcel={clickedExcel}
        excel={excel}
        isExcel={isExcel}
        setIsExcel={setIsExcel}
        excelLoading={excelLoading}
        createdAtStart={createdAtStart}
        createdAtEnd={createdAtEnd}
        setCreatedAtStart={setCreatedAtStart}
        setCreatedAtEnd={setCreatedAtEnd}
        onStatusFilterChanges={onStatusFilterChanges}
        setAppendDateFilter={setAppendDateFilter}
        appendDateFilter={appendDateFilter}
        clearDate={clearDate}
        setClearDate={setClearDate}
        setClearJoiningDate={setClearJoiningDate}
        clear={clear}
        setClear={setClear}
        error={error}
        setError={setError}
        dataSign={dataSign}
        setDateError={setDateError}
        subEvents={subEvents}
      />
    </>
  )
}
export default HiringStatus
